export default __webpack_public_path__ + "static/media/app_store.cfd62734.svg";